import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Menu,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment/moment";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appIcons } from "../../assets";
import { CURRENCY } from "../../lib/variables";
import { getDuration } from "../../utils";
import GlobalButton from "../button";
import PackageProductsDialog from "../packageProductDialog";
import { t } from "i18next";
import { useSelector } from "react-redux";

const tableContainerStyle = {
  "&.MuiTableContainer-root .MuiTable-root .MuiTableHead-root": {
    backgroundColor: "primary.main",
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: "text.white",
      fontSize: "0.875rem",
    },

  "& .MuiTableCell-root .MuiTypography-body1 ": {
    fontSize: "0.875rem",
  },
  "&.MuiTableContainer-root": {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    // "&::-webkit-scrollbar-thumb": {
    //   backgroundColor: appcolors.primary,
    //   // borderRadius: "4px",
    // },
    // "&::-webkit-scrollbar-thumb:hover": {
    //   backgroundColor: appcolors.secondary,
    // },
    // "&::-webkit-scrollbar-track": {
    //   backgroundColor: appcolors.lightGrey,
    // },
  },
};

export default function DynamicTable({
  tableProps,
  tableHeader,
  tableData,
  displayRows,
  showDetail,
  showActions,
  showEdit,
  handleEdit,
  showDelete,
  handleDelete,
  handleViewDetail,
  handleReview,
  handleCancelOrder,
  handleTrack,
  showPagination = false,
  handleOrderPackage,
  handleCopyUrl,
}) {
  const openPackageProductsDialog = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [meunAnchorEl, setMenuAnchorEl] = useState(null);
  const openAddEditMenu = Boolean(meunAnchorEl);
  const [rowData, setRowData] = useState(null);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickAddEditMenu = (event, row, index) => {
    setMenuAnchorEl(event.currentTarget);
    setRowData({ row, index });
  };

  const handleCloseAddEditMenu = () => {
    setMenuAnchorEl(null);
  };

  const orderStatusColors = (status) => {
    if (status === "Pending") return "orange";
    if (status === "Accepted") return "blue";
    if (status === "Delivered") return "green";
    if (status === "Cancelled") return "red";
    if (status === "User Cancelled") return "red";
  };

  const appointmentStatusColors = (status) => {
    if (status === "pending") return "orange";
    if (status === "accepted") return "blue";
    if (status === "completed") return "green";
    if (status === "cancelled") return "red";
    if (status === "started") return "purple";
    if (status === "user cancelled") return "red";
  };

  const renderColorBox = (colorname, color) => {
    return (
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          border: "1px solid #ccc",
          borderRadius: 1,
          padding: "4px 8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <Box
          sx={{
            fontSize: "14px",
            color: "#333",
            fontWeight: 500,
            marginRight: "8px",
          }}
        >
          {colorname}
        </Box>
        <Box
          sx={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid #ddd",
          }}
        ></Box>
      </Stack>
    );
  };

  return (
    <>
      <TableContainer sx={tableContainerStyle}>
        <Table {...tableProps}>
          <TableHead>
            <TableRow>
              {tableHeader?.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {t(header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row, index) => {
              return (
                <React.Fragment key={index}>
                  <TableRow>
                    {displayRows.map((val) => {
                      return (
                        <React.Fragment key={val}>
                          {val === "idAscending" ? (
                            <TableCell>{index + 1}</TableCell>
                          ) : val === "product_item_price" ? (
                            <TableCell>{`${row.price} USD`}</TableCell>
                          ) : val === "fees" ? (
                            <TableCell>{`${row.fees} USD`}</TableCell>
                          ) : val === "date_time" ? (
                            <TableCell>
                              {moment(row.createdAt).format("DD-MM-YYYY")}{" "}
                              <br /> {moment(row.createdAt).format("hh:mm a")}
                            </TableCell>
                          ) : val === "product_item" ? (
                            <TableCell>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={2}
                              >
                                <Avatar
                                  src={row.image}
                                  sx={{
                                    borderRadius: 2.5,
                                    height: 45,
                                    width: 45,
                                  }}
                                />
                                <Typography variant="body1" fontWeight={500}>
                                  {row.name}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val === "service_used" ? (
                            <TableCell>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={2}
                              >
                                <Avatar
                                  src={row.serviceSubCategoryId.image}
                                  sx={{
                                    borderRadius: 2.5,
                                    height: 45,
                                    width: 45,
                                  }}
                                />
                                <Typography
                                  variant="body1"
                                  fontWeight={500}
                                  textTransform={"capitalize"}
                                >
                                  {
                                    row.serviceSubCategoryId.name[
                                      currentLanguage
                                    ]
                                  }
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val === "service_inputs" ? (
                            <TableCell>
                              <Typography
                                variant="body1"
                                fontWeight={500}
                                textTransform={"capitalize"}
                              >
                                {row.userInputs.selectedType === "room+area" &&
                                  row.userInputs.selectedOption === "room" &&
                                  `${row.userInputs?.userInput} room`}
                                {row.userInputs.selectedType === "room+area" &&
                                  row.userInputs.selectedOption ===
                                    "apartment" &&
                                  `${row.userInputs?.userInput} sqft`}
                                {row.userInputs.selectedType === "room+area" &&
                                  row.userInputs.selectedOption === "deluxe" &&
                                  `${row.userInputs?.userInput} sqft`}
                                {row.userInputs.selectedType === "area" &&
                                  row.userInputs.selectedOption === "area" &&
                                  `${row.userInputs?.userInput} sqft`}
                                {row.userInputs.selectedType === "fixed" &&
                                  row.userInputs.selectedOption === "fixed" &&
                                  `car`}
                                {row.userInputs.selectedType ===
                                  "interior+exterior" &&
                                  row.userInputs.selectedOption ===
                                    "interior" &&
                                  `Interior`}
                                {row.userInputs.selectedType ===
                                  "interior+exterior" &&
                                  row.userInputs.selectedOption ===
                                    "exterior" &&
                                  `Exterior`}
                                {row.userInputs.selectedType ===
                                  "interior+exterior" &&
                                  row.userInputs.selectedOption === "both" &&
                                  `Interior+Exterior`}
                              </Typography>
                            </TableCell>
                          ) : val === "service_duration" ? (
                            <TableCell>
                              <Typography variant="body1" fontWeight={500}>
                                {getDuration(row.start, row.end)}
                              </Typography>
                            </TableCell>
                          ) : val === "service_price" ? (
                            <TableCell>
                              <Typography variant="body1" fontWeight={500}>
                                ${row.totalCost}
                              </Typography>
                            </TableCell>
                          ) : val === "service_status" ? (
                            <TableCell>
                              <Chip
                                sx={{
                                  color: "text.white",
                                  borderRadius: 1,
                                  bgcolor: appointmentStatusColors(row.status),
                                  textTransform: "capitalize",
                                }}
                                label={row.status}
                              />
                            </TableCell>
                          ) : val === "download_invoice_btn" ? (
                            <TableCell>
                              <GlobalButton
                                variant={"outlined"}
                                btnText={"download"}
                                startIcon={
                                  <img
                                    src={appIcons.blackSortAscendingIcon}
                                    width={25}
                                  />
                                }
                                styleProps={{
                                  color: "text.black",
                                  boxShadow: "none",
                                  fontSize: "0.75rem",
                                }}
                              />
                            </TableCell>
                          ) : val === "custom_status_chip" ? (
                            <TableCell>
                              <Chip
                                icon={
                                  <CheckCircleIcon
                                    sx={{ color: "text.vividMalachite" }}
                                  />
                                }
                                label={t("paid")}
                              />
                            </TableCell>
                          ) : val === "user_name" ? (
                            <TableCell>
                              {`${row.firstname} ${row.lastname}`}
                            </TableCell>
                          ) : val === "order_id" ? (
                            <TableCell>{`#${row.orderId}`}</TableCell>
                          ) : val === "total_bill" ? (
                            <TableCell>{`${CURRENCY} ${row.totalBill}`}</TableCell>
                          ) : val === "order_item" ? (
                            <TableCell>{row.order?.length}</TableCell>
                          ) : val === "order_detail" ? (
                            <TableCell>
                              <Chip
                                icon={<RemoveRedEyeIcon />}
                                label={"View Detail"}
                                onClick={() => handleViewDetail(row, index)}
                              />
                            </TableCell>
                          ) : val === "total_tax" ? (
                            <TableCell>{row.tax}%</TableCell>
                          ) : val === "product_name" ? (
                            <TableCell
                              sx={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate(`/product/${row.productUrl}`)
                              }
                            >
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={1}
                                width={"400px"}
                              >
                                <Avatar
                                  src={row.coverImage}
                                  sx={{
                                    height: 55,
                                    width: 55,
                                    borderRadius: "6px",
                                    backgroundColor: "#edebeb",
                                    border: "1px solid #edebeb",
                                  }}
                                />
                                <Typography
                                  variant={"body1"}
                                  textTransform={"capitalize"}
                                >
                                  {row.name[currentLanguage]}
                                </Typography>
                              </Stack>
                            </TableCell>
                          ) : val === "product_final_amount" ? (
                            <TableCell>
                              {`${CURRENCY} ${row.finalPrice}`}
                            </TableCell>
                          ) : val === "product_final_price" ? (
                            <TableCell>
                              {`${CURRENCY} ${
                                row.finalPrice * row.selectedQty
                              }`}
                            </TableCell>
                          ) : val === "product_selected_size" ? (
                            <TableCell>
                              {row?.selectedSize?.name ? (
                                <Chip
                                  sx={{ borderRadius: 1 }}
                                  label={row?.selectedSize?.name}
                                />
                              ) : row.selectedSizeWithColor ? (
                                <Chip
                                  sx={{ borderRadius: 1 }}
                                  label={row?.selectedSizeWithColor?.size}
                                />
                              ) : (
                                "_"
                              )}
                            </TableCell>
                          ) : val === "product_selected_color" ? (
                            <TableCell>
                              {row?.selectedColor?.color
                                ? renderColorBox(
                                    row?.selectedColor?.colorName,
                                    row?.selectedColor?.color
                                  )
                                : row.selectedSizeWithColor
                                ? renderColorBox(
                                    row?.selectedSizeWithColor?.colorName,
                                    row?.selectedSizeWithColor?.color
                                  )
                                : "_"}
                            </TableCell>
                          ) : val === "product_selected_weight" ? (
                            <TableCell>
                              {row?.selectedWeight ? (
                                <Chip
                                  sx={{ borderRadius: 1 }}
                                  label={row?.selectedWeight?.name}
                                />
                              ) : (
                                "_"
                              )}
                            </TableCell>
                          ) : val === "product_package" ? (
                            <TableCell>
                              {row.products?.length > 0 &&
                              row.type === "Package" ? (
                                <GlobalButton
                                  variant={"contained"}
                                  btnText={"viewProducts"}
                                  handleClickBtn={() =>
                                    openPackageProductsDialog.current.openDialog(
                                      {
                                        data: row.products,
                                      }
                                    )
                                  }
                                  styleProps={{
                                    fontSize: "0.75rem",
                                    width: "max-content",
                                    height: 40,
                                  }}
                                />
                              ) : (
                                "_"
                              )}
                            </TableCell>
                          ) : val === "product_status" ? (
                            <TableCell>
                              <Chip
                                sx={{
                                  color: "text.white",
                                  borderRadius: 1,
                                  bgcolor: orderStatusColors(row.orderStatus),
                                }}
                                label={row.orderStatus}
                              />
                            </TableCell>
                          ) : val === "product_delivered_at" ? (
                            <TableCell>
                              {row.deliveredAt
                                ? moment(row.deliveredAt).format("MM-DD-YYYY")
                                : "_"}
                            </TableCell>
                          ) : val === "show_review_btn" ? (
                            <TableCell>
                              {row.orderStatus === "Delivered" ? (
                                <GlobalButton
                                  variant={"contained"}
                                  btnText={row.isReview ? "reviewed" : "review"}
                                  disabled={row.isReview}
                                  handleClickBtn={() =>
                                    handleReview(row, index)
                                  }
                                  styleProps={{
                                    fontSize: "0.75rem",
                                    width: "max-content",
                                    height: 38,
                                  }}
                                />
                              ) : (
                                "_"
                              )}
                            </TableCell>
                          ) : val === "show_cancel_btn" ? (
                            <TableCell>
                              {row.orderStatus === "Pending" ? (
                                <GlobalButton
                                  variant={"contained"}
                                  btnText={"cancel"}
                                  disabled={row.isReview}
                                  handleClickBtn={() =>
                                    handleCancelOrder(row, index)
                                  }
                                  styleProps={{
                                    fontSize: "0.75rem",
                                    width: "max-content",
                                    height: 38,
                                    backgroundColor: "red",
                                  }}
                                />
                              ) : (
                                "_"
                              )}
                            </TableCell>
                          ) : val === "transaction_type" ? (
                            <TableCell>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={1}
                              >
                                <Typography textTransform={"capitalize"}>
                                  {row?.transactionType}
                                </Typography>
                                {row?.transactionType === "credit" ? (
                                  <CallReceivedIcon
                                    htmlColor="green"
                                    fontSize="small"
                                  />
                                ) : (
                                  <NorthEastIcon
                                    htmlColor="red"
                                    fontSize="small"
                                  />
                                )}
                              </Stack>
                            </TableCell>
                          ) : val === "total_amount" ? (
                            <TableCell>
                              {CURRENCY} {row?.amount}
                            </TableCell>
                          ) : val === "payment_method" ? (
                            <TableCell>
                              <Chip
                                label={row?.paymentMethod}
                                color="success"
                                // variant="outlined"
                              />
                            </TableCell>
                          ) : val === "payment_against" ? (
                            <TableCell>
                              <Typography textTransform={"capitalize"}>
                                {row?.against}
                              </Typography>
                            </TableCell>
                          ) : val === "refund_detail" ? (
                            <TableCell>
                              {row.against === "product" ? (
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  gap={1}
                                >
                                  <Avatar
                                    src={row?.order?.coverImage}
                                    sx={{
                                      borderRadius: "10px",
                                      height: 50,
                                      width: 50,
                                    }}
                                  />
                                  <Box>
                                    <Typography
                                      fontWeight={600}
                                      textTransform={"capitalize"}
                                      noWrap
                                    >
                                      {row?.order?.name}
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                      {row?.order?.description
                                        .split(" ")
                                        .slice(0, 6)
                                        .join(" ") + "......"}
                                    </Typography>
                                  </Box>
                                </Stack>
                              ) : row.against === "appointment" ? (
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  gap={2}
                                >
                                  <Avatar
                                    src={
                                      row?.appointment
                                        ?.serviceSubCategoryDetails?.image
                                    }
                                    sx={{
                                      borderRadius: "10px",
                                      height: 50,
                                      width: 50,
                                    }}
                                  />
                                  <Box>
                                    <Typography
                                      fontWeight={600}
                                      textTransform={"capitalize"}
                                      noWrap
                                    >
                                      {
                                        row?.appointment
                                          ?.serviceSubCategoryDetails?.name
                                      }
                                    </Typography>
                                    <Typography variant="body2" noWrap>
                                      {row?.appointment?.serviceSubCategoryDetails?.description
                                        .split(" ")
                                        .slice(0, 6)
                                        .join(" ") + "......"}
                                    </Typography>
                                  </Box>
                                </Stack>
                              ) : (
                                "__"
                              )}
                            </TableCell>
                          ) : val === "user_package" ? (
                            <TableCell>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={2}
                              >
                                <Avatar
                                  src={row.coverImage}
                                  sx={{
                                    borderRadius: 2.5,
                                    height: 45,
                                    width: 45,
                                  }}
                                />
                                <Box maxWidth={"300px"}>
                                  <Typography variant="body1" fontWeight={500}>
                                    {row.name[currentLanguage]}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    noWrap
                                    lineHeight={1}
                                  >
                                    {row.description[currentLanguage]}
                                  </Typography>
                                </Box>
                              </Stack>
                            </TableCell>
                          ) : val === "user_package_category" ? (
                            <TableCell>
                              <Typography textTransform={"capitalize"}>
                                {row.categoryId.name[currentLanguage]}
                              </Typography>
                            </TableCell>
                          ) : val === "user_package_sub_category" ? (
                            <TableCell>
                              {row?.subCategoryId.map((x) => (
                                <Typography
                                  variant="body2"
                                  textTransform={"capitalize"}
                                  mb={0.5}
                                >
                                  {x.name[currentLanguage]}
                                </Typography>
                              )) || "__"}
                            </TableCell>
                          ) : val === "user_package_price" ? (
                            <TableCell>
                              {CURRENCY} {row.finalPrice}
                            </TableCell>
                          ) : val === "user_package_order" ? (
                            <TableCell>
                              <GlobalButton
                                btnText={"order"}
                                handleClickBtn={() =>
                                  handleOrderPackage(row, index)
                                }
                              />
                            </TableCell>
                          ) : val === "user_package_copy_url" ? (
                            <TableCell>
                              <GlobalButton
                                btnText={"URL"}
                                disabled={row.status === true ? false : true}
                                handleClickBtn={() => handleCopyUrl(row, index)}
                              />
                            </TableCell>
                          ) : val === "user_package_live" ? (
                            <TableCell>
                              {row?.status ? (
                                <Chip
                                  label={t("live")}
                                  sx={{
                                    color: "primary.main",
                                    height: "28px",
                                    fontWeight: "600",
                                  }}
                                />
                              ) : (
                                <Tooltip title={t("orderFirstToLive")}>
                                  <Chip
                                    label={t("notLive")}
                                    sx={{
                                      color: "primary.main",
                                      height: "28px",
                                      fontWeight: "600",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </TableCell>
                          ) : val === "withdraw_amount" ? (
                            <TableCell>{`${CURRENCY} ${row.amount}`}</TableCell>
                          ) : val === "withdraw_status" ? (
                            <TableCell>
                              <Chip
                                label={t(row.status)}
                                sx={{
                                  color: "text.white",
                                  borderRadius: 1,
                                  textTransform: "capitalize",
                                  bgcolor:
                                    row.status === "pending"
                                      ? "orange"
                                      : row.status === "approved"
                                      ? "blue"
                                      : row.status === "rejected"
                                      ? "red"
                                      : row.status === "paid"
                                      ? "green"
                                      : "grey",
                                }}
                              />
                            </TableCell>
                          ) : val === "withdraw_reason" ? (
                            <TableCell>
                              {row.status === "rejected" ? (
                                <Typography variant="body2">
                                  {row.reason || "__"}
                                </Typography>
                              ) : (
                                <Typography variant="body2">__</Typography>
                              )}
                            </TableCell>
                          ) : val === "withdraw_receipt" ? (
                            <TableCell>
                              {row?.receipt && row?.status === "paid" ? (
                                <GlobalButton
                                  btnText={"view"}
                                  handleClickBtn={() =>
                                    window.open(row?.receipt, "_blank")
                                  }
                                  styleProps={{
                                    borderRadius: 1,
                                    height: "30px",
                                    width: "auto",
                                  }}
                                />
                              ) : (
                                "__"
                              )}
                            </TableCell>
                          ) : val === "actions" ? (
                            <TableCell>
                              {showDetail && (
                                <Stack
                                  onClick={() => handleTrack(row)}
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={appIcons.purpleSigleArrowRightIcon}
                                    width={28}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "0.75rem !important",
                                    }}
                                    fontWeight={500}
                                  >
                                    {t("track")}
                                  </Typography>
                                </Stack>
                              )}
                              {showActions && (
                                <>
                                  <Button
                                    disableRipple
                                    id="addEdit-menu-button"
                                    aria-controls={
                                      openAddEditMenu
                                        ? "addEdit-menu"
                                        : undefined
                                    }
                                    startIcon={
                                      <MoreVertIcon htmlColor="#000000" />
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={
                                      openAddEditMenu ? "true" : undefined
                                    }
                                    sx={{
                                      width: "auto",
                                      padding: "5px",
                                      minWidth: 0,
                                      boxShadow: "none",
                                      "& .MuiButton-startIcon": {
                                        mx: 0,
                                      },
                                      "&:hover": {
                                        backgroundColor: "#ffffff",
                                      },
                                    }}
                                    onClick={(e) =>
                                      handleClickAddEditMenu(e, row, index)
                                    }
                                  ></Button>
                                  <Menu
                                    id="addEdit-menu"
                                    anchorEl={meunAnchorEl}
                                    open={openAddEditMenu}
                                    onClose={handleCloseAddEditMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "addEdit-menu-button",
                                    }}
                                    sx={{
                                      ".MuiMenu-paper": {
                                        boxShadow: "none",
                                        border: "1px solid grey",
                                      },
                                    }}
                                  >
                                    <Stack
                                      direction={"column"}
                                      alignItems={"center"}
                                      spacing={1}
                                      paddingX={1}
                                    >
                                      {showEdit && (
                                        <img
                                          src={appIcons.editIcon}
                                          alt="delete-icon"
                                          width={20}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleEdit(rowData);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                      {showDelete && (
                                        <img
                                          src={appIcons.deleteIcon}
                                          alt="delete-icon"
                                          width={16}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleDelete(rowData);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                    </Stack>
                                  </Menu>
                                </>
                              )}
                            </TableCell>
                          ) : (
                            <TableCell>
                              <Typography fontSize={13} lineHeight="normal">
                                {row[val]}
                              </Typography>
                            </TableCell>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ display: showPagination ? "block" : "none" }}
        rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <PackageProductsDialog ref={openPackageProductsDialog} />
    </>
  );
}
